let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2hZsW")).then(() => parcelRequire('5QXFC'));